import React, { useReducer, useEffect, useContext } from "react";
import bloqueadosReservaReducer from "./bloqueadosReservaReducer";
import bloqueadosReservaContext from "./bloqueadosReservaContext";

import {
    getBloqueadosReserva,
    addBloqueadoReserva,
    updateBloqueadoReserva,
    deleteBloqueadoReserva,
    deleteAllBloqueadosReserva
} from "../../api/bloqueadoReserva.js";

import {
    ACTUALIZAR_BLOQUEADOS,
} from "./bloqueadosReservaAction";

import { SocketContext } from "../socket/socket.js";
import authContext from "../authentication/authContex.js";

const BloqueadosReservaState = props => {

    const initialState = {
        bloqueados: [],
        cargando: false,
        error: ""
    };

    const server = useContext(SocketContext);
    const [state, dispatch] = useReducer(bloqueadosReservaReducer, initialState);
    const auContext = useContext(authContext);
    const { usuario } = auContext;

    const actualizarBloqueados = async () => {
        try {
            const resp = await getBloqueadosReserva();
            dispatch({
                type: ACTUALIZAR_BLOQUEADOS,
                payload: resp.data.data
            });
            return resp.data.data;
        } catch (error) {
            console.log(error);
        }
    }

    const agregarBloqueado = async (bloqueado) => {
        try {
            const resp = await addBloqueadoReserva(bloqueado);
            return resp;
        } catch (error) {
            console.log("error en agregarBloqueado");
            console.log(error);
            return false;
        }
    }

    const modificarBloqueado = async (id, updates) => {
        try {
            const resp = await updateBloqueadoReserva(id, updates);
            return resp;
        } catch (error) {
            console.log("error en modificarBloqueado");
            console.log(error);
            return false;
        }
    }

    const eliminarBloqueado = async (id) => {
        try {
            const resp = await deleteBloqueadoReserva(id);
            return resp;
        } catch (error) {
            console.log("error en eliminarBloqueado");
            console.log(error);
            return false;
        }
    }

    const eliminarTodos = async () => {
        try {
            const resp = await deleteAllBloqueadosReserva();
            await actualizarBloqueados();
            return resp;
        } catch (error) {
            console.log("error en eliminarTodos");
            console.log(error);
            return false;
        }
    }

    useEffect(() => {
        if (usuario != null) actualizarBloqueados();
    }, [usuario]);

    useEffect(() => {
        if (server) {
            server.on('bloqueadoReservaUpdated', () => {
                actualizarBloqueados();
            });

            return () => {
                server.off('bloqueadoReservaUpdated');
            }
        }
    }, [server]);

    return (
        <bloqueadosReservaContext.Provider
            value={{
                bloqueados: state.bloqueados,
                cargando: state.cargando,
                error: state.error,
                actualizarBloqueados,
                agregarBloqueado,
                modificarBloqueado,
                eliminarBloqueado,
                eliminarTodos
            }}
        >
            {props.children}
        </bloqueadosReservaContext.Provider>
    )
}

export default BloqueadosReservaState;
